<ng-container *transloco="let _t">

<div *ngIf="incidents.length>0 else nothing">
<table *ngIf="filterService!=undefined && filterService.showedData != undefined"
	class="mat-elevation-z8 table-bordered table-striped container">
	<thead><tr class="darkbg">
		<th class="datetime">
			<cmat-thbtns class="cmat-thbtns" *ngIf="selectedBuildingsList.length==0"
				[filterService]="filterService"
				[subObject]="'dtfacts'" [prop]="'date'"
				[showFilter]="false">
			</cmat-thbtns>
			{{ _t('date-time')}}
		</th>
		<th class="redactor">
			<cmat-thbtns class="cmat-thbtns" *ngIf="selectedBuildingsList.length==0"
				[filterService]="filterService"
				[subObject]="'redactor'" [prop]="'name'">
			</cmat-thbtns>
			{{ _t('writer') }}
		</th>
		<th class="nature">{{ _t('Nature') }}
		</th>
		<th class="grav">
			<cmat-thbtns class="cmat-thbtns" *ngIf="selectedBuildingsList.length==0"
				[filterService]="filterService"
				[prop]="'gravity'">
			</cmat-thbtns>
			Gravité
		</th>
		<th class="status">
			<cmat-thbtns class="cmat-thbtns" *ngIf="selectedBuildingsList.length==0"
				[filterService]="filterService"
				[prop]="'status'">
			</cmat-thbtns>
			Statut
		</th>
	</tr></thead>
	<tr *ngFor="let incident of filterService.showedData"
		[ngClass]="{
        new: incident.status=='Nouveau',
        wip: incident.status=='En cours',
        done: incident.status=='Résolu'
      }"
		(click)="openIncident(incident)" style="cursor:pointer;">
		<td>{{incident.dtfacts.date | date:'short':undefined:'fr-FR' | replace:" ":"\n à "}}</td>
		<td>{{incident.redactor.name}}</td>
		<td>{{incident.nature}}</td>
		<td [ngClass]="{
			'grav1':incident.gravity==1,
			'grav2':incident.gravity==2,
			'grav3':incident.gravity==3
		}">
			<span>{{incident.gravity}}</span></td>
		<td>{{incident.status}}</td>
	</tr>
</table>
</div>

<ng-template #nothing>
	<p class="text-center" >{{ _t('incident-list-p-0') }}</p>
</ng-template>

</ng-container>
